<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-25
    	描述：组件-选择用户
    -->
  <el-dialog title="选择" :visible.sync="dialogVisible" @close="cancelFunc" :append-to-body="true"
   :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
   

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%"
        ref="flag"
        v-loading="loading" @selection-change="handleSelectionChange">
 
          <el-table-column prop="text" label="日期"></el-table-column>


          <el-table-column type="selection" width="45" 
          
          
          v-if="multi"></el-table-column>
          <el-table-column label="操作" width="80" v-else>
            <template slot-scope="scope">
              <el-button type="primary" size="mini" 
              
              @click="selectUser(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="confirmFunc">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import DataApi from '@/api/data.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*选中的*/
      multipleSelection: [],
      /*是否显示*/
      dialogVisible: false,
      fl:false,
      tableData:[
        {
          id:1,
          text:"1号",
        },{
          id:2,
          text:"2号",
        },{
          id:3,
          text:"3号",
        },{
          id:4,
          text:"4号",
        },{
          id:5,
          text:"5号",
        },{
          id:6,
          text:"6号",
        },{
          id:7,
          text:"7号",
        },{
          id:8,
          text:"8号",
        },{
          id:9,
          text:"9号",
        },{
          id:10,
          text:"10号",
        },{
          id:11,
          text:"11号",
        },{
          id:12,
          text:"12号",
        },{
          id:13,
          text:"13号",
        },{
          id:14,
          text:"14号",
        },{
          id:15,
          text:"15号",
        },{
          id:16,
          text:"16号",
        },{
          id:17,
          text:"17号",
        },{
          id:18,
          text:"18号",
        },{
          id:19,
          text:"19号",
        },{
          id:20,
          text:"20号",
        },{
          id:21,
          text:"21号",
        },{
          id:22,
          text:"22号",
        },{
          id:23,
          text:"23号",
        },{
          id:24,
          text:"24号",
        },{
          id:25,
          text:"25号",
        },{
          id:26,
          text:"26号",
        },{
          id:27,
          text:"27号",
        },{
          id:28,
          text:"28号",
        },{
          id:29,
          text:"29号",
        },{
          id:30,
          text:"30号",
        },{
          id:31,
          text:"31号",
        }
      ],
    };
  },
  props: {
    // 开启弹窗
    is_open: Boolean,
    // 是否多选
    multi: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    code:String,
    selectData:Array,
  },
  watch: {
    is_open: function(n, o) {
      if (n != o) {
        this.dialogVisible = n;
        var self = this;
    
        self.$nextTick(() => {
          setTimeout(() => {
              for (let j = 0; j < self.tableData.length; j++) {
                self.tableData[j].flag = false;
              }
              for(var i=0;i<self.selectData.length;i++){
                for (let j = 0; j < self.tableData.length; j++) {
                    if(self.selectData[i].id == self.tableData[j].id){
                      self.tableData[j].flag = true;
                      break;
                    }
                }
              }

              for (let i = 0; i < self.tableData.length; i++) {
                if (self.tableData[i].flag) {
                  self.$refs.flag.toggleRowSelection(self.tableData[i]);
                }
            }
            }, 500);
        })

      }
    }
  },

  methods: {
     /*是否可以勾选*/
     selectableFunc(e){
      if(typeof e.noChoose !=='boolean'){
        return true;
      }
      return e.noChoose;
    },
    /*关闭弹窗*/
    cancelFunc(e) {
      if( !this.fl){
        this.emitFunc();
      }
    
    },

    /*发送事件*/
    emitFunc(e) {
      this.dialogVisible = false;
      if (e && typeof e != 'undefined') {
        this.$emit('close', {
          type: 'success',
          params: e
        });
      } else {
        this.$emit('close', {
          type: 'error'
        });
      }
    },
      /*点击确定*/
      confirmFunc() {
        let params = this.multipleSelection;
        this.emitFunc(params);
        var self  = this;
        self.fl = true;
        setTimeout(function(){
          self.fl = false;
        },2000)
    },
    /*监听单选按钮选中事件*/
    selectUser(val) {
      this.multipleSelection = val;
      this.confirmFunc();
    },

    /*选择用户*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/user/dates.vue